import { fork } from 'redux-saga/effects';

import { actions, selectors } from 'domain/session';
import { listNavigator } from 'sagas/common';
import filters from 'filters/session';

export default function* navigator() {
  yield fork(listNavigator, { modelName: 'Session', actions, selectors, filters } );
}
